@if (selectedIntervention || selectedTechnicianDirect) {
  <!-- Compact header : date/nom + tabs + close en 1 ligne -->
  <div class="panel-header">
    <div class="flex items-center gap-2 flex-1 min-w-0">
      <i class="pi pi-calendar-clock text-blue-400 text-xs flex-shrink-0"></i>
      @if (selectedIntervention) {
        <span
          class="text-xs font-medium text-blue-400 truncate"
          [title]="
            'Disponibilités pour ' +
            (selectedIntervention.startDate | date: 'dd/MM/yyyy')
          "
        >
          {{ selectedIntervention.startDate | date: 'dd/MM/yyyy' }}
        </span>
      } @else if (selectedTechnicianDirect) {
        <span
          class="text-xs font-medium text-blue-400 truncate"
          [title]="
            selectedTechnicianDirect.firstname +
            ' ' +
            selectedTechnicianDirect.lastname
          "
        >
          {{ selectedTechnicianDirect.firstname }}
          {{ selectedTechnicianDirect.lastname }}
        </span>
      }
      <!-- Tabs inline -->
      <div class="flex items-center gap-1 ml-auto flex-shrink-0">
        <button
          type="button"
          class="tab-btn"
          [class.tab-active]="activeTab === 'slots'"
          (click)="setActiveTab('slots')"
        >
          Créneaux
        </button>
        <button
          type="button"
          class="tab-btn"
          [class.tab-active]="activeTab === 'emptyDays'"
          (click)="setActiveTab('emptyDays')"
        >
          Creuses
          @if (emptyDaysSlots.length > 0) {
            <span class="tab-badge">{{ emptyDaysSlots.length }}</span>
          }
        </button>
      </div>
    </div>
    <button
      class="close-btn"
      (click)="onClose()"
      title="Fermer"
      aria-label="Fermer le panneau de disponibilités"
    >
      <i class="pi pi-times"></i>
    </button>
  </div>

  @if (activeTab === 'slots') {
    <div class="availabilities-scroll">
      @if (loadingSelectedInterventionAvailabilities) {
        <div class="p-2">
          <div class="flex flex-col gap-2">
            <p-skeleton width="100%" height="36px"></p-skeleton>
            <p-skeleton width="100%" height="36px"></p-skeleton>
            <p-skeleton width="100%" height="36px"></p-skeleton>
            <p-skeleton width="80%" height="36px"></p-skeleton>
          </div>
        </div>
      } @else if (selectedInterventionAvailabilities) {
        <!-- Tech + summary bar -->
        <div class="tech-summary-bar">
          <div
            class="tech-avatar"
            [style.background-color]="
              getTechnicianColorByEmail(
                selectedInterventionAvailabilities.user_email
              )
            "
          >
            {{
              getTechnicianInitialsByEmail(
                selectedInterventionAvailabilities.user_email
              )
            }}
          </div>
          <span
            class="text-xs font-medium text-neutral-200 truncate"
            [title]="selectedInterventionAvailabilities.user_name"
          >
            {{ selectedInterventionAvailabilities.user_name }}
          </span>
          <span class="text-neutral-600 mx-0.5">&middot;</span>
          @if (selectedTechnicianDirect) {
            <span class="text-xs text-green-400 font-medium">
              {{
                selectedInterventionAvailabilities.availabilities
                  .available_slots.length
              }}
              créneaux
            </span>
          } @else if (loadingSlotTravelInfo) {
            <span class="text-xs text-blue-400"
              ><i class="pi pi-spin pi-spinner text-xs"></i> Analyse...</span
            >
          } @else if (slotTravelInfo.size > 0) {
            <div class="flex items-center gap-1.5 flex-wrap">
              @if (getFeasibleSlotsCount() > 0) {
                <span class="text-xs font-medium text-green-400"
                  >{{ getFeasibleSlotsCount() }} OK</span
                >
              }
              @if (getAdjustableSlotsCount() > 0) {
                <span class="text-xs font-medium text-yellow-400"
                  >{{ getAdjustableSlotsCount() }} serrés</span
                >
              }
              @if (getShiftSlotsCount() > 0) {
                <span class="text-xs font-medium text-purple-400"
                  >{{ getShiftSlotsCount() }} décaler</span
                >
              }
              @if (
                getFeasibleSlotsCount() === 0 &&
                getAdjustableSlotsCount() === 0 &&
                getShiftSlotsCount() === 0
              ) {
                <span class="text-xs font-medium text-red-400">Aucun</span>
              }
            </div>
          } @else {
            <span class="text-xs text-neutral-400">
              {{
                selectedInterventionAvailabilities.availabilities
                  .available_slots.length
              }}
              créneaux
            </span>
          }
          <span class="ml-auto text-xs text-neutral-500 flex-shrink-0">{{
            formatDuration(interventionDuration)
          }}</span>
        </div>

        <!-- Slots -->
        @if (
          selectedInterventionAvailabilities.availabilities.available_slots
            .length > 0
        ) {
          <div class="slots-list">
            @if (selectedTechnicianDirect) {
              @for (
                availableSlot of selectedInterventionAvailabilities
                  .availabilities.available_slots;
                track $index
              ) {
                @let slotDuration = getSlotDurationMinutes(availableSlot);
                <div
                  class="slot-card slot-ok"
                  (click)="
                    onSlotClick(
                      availableSlot,
                      selectedInterventionAvailabilities.user_email
                    )
                  "
                >
                  <div class="flex items-center justify-between">
                    <span class="slot-time"
                      >{{ availableSlot.start | date: 'HH:mm' }} →
                      {{ availableSlot.end | date: 'HH:mm' }}</span
                    >
                    <span class="slot-badge bg-green-600">OK</span>
                  </div>
                  <div class="slot-details">
                    <span class="detail-chip text-neutral-400">{{
                      availableSlot.start | date: 'EEE dd'
                    }}</span>
                    <span class="detail-chip text-neutral-400">{{
                      formatDuration(slotDuration)
                    }}</span>
                  </div>
                </div>
              }
            } @else if (!loadingSlotTravelInfo && slotTravelInfo.size > 0) {
              @for (
                slotItem of getSortedAvailableSlots();
                track slotItem.originalIndex
              ) {
                @let availableSlot = slotItem.slot;
                @let travelInfo =
                  getSlotTravelInfoByOriginalIndex(slotItem.originalIndex);
                <div
                  class="slot-card"
                  [ngClass]="{
                    'slot-ok':
                      (!travelInfo || travelInfo.isFeasible) &&
                      !isShiftSlot(slotItem.originalIndex),
                    'slot-shift': isShiftSlot(slotItem.originalIndex),
                    'slot-tight': travelInfo && travelInfo.needsAdjustment,
                    'slot-nogo':
                      travelInfo &&
                      !travelInfo.isFeasible &&
                      !travelInfo.needsAdjustment &&
                      !isShiftSlot(slotItem.originalIndex),
                  }"
                  (click)="
                    onSlotClick(
                      availableSlot,
                      selectedInterventionAvailabilities.user_email
                    )
                  "
                >
                  <div class="flex items-center justify-between">
                    <span class="slot-time"
                      >{{ availableSlot.start | date: 'HH:mm' }} →
                      {{ availableSlot.end | date: 'HH:mm' }}</span
                    >
                    @if (isShiftSlot(slotItem.originalIndex)) {
                      <span
                        class="slot-badge bg-purple-600"
                        [title]="
                          'Décaler : ' +
                          (travelInfo?.shiftedEventTitle || 'RDV existant')
                        "
                        >DÉCALER</span
                      >
                    } @else if (!travelInfo || travelInfo.isFeasible) {
                      <span class="slot-badge bg-green-600">OK</span>
                    } @else if (travelInfo.needsAdjustment) {
                      <span class="slot-badge bg-yellow-600">SERRÉ</span>
                    } @else {
                      <span class="slot-badge bg-red-700">✗</span>
                    }
                  </div>
                  @if (
                    isShiftSlot(slotItem.originalIndex) &&
                    travelInfo?.shiftedEventTitle
                  ) {
                    <div
                      class="flex items-center gap-1 mt-1 text-xs text-purple-300"
                    >
                      <i
                        class="pi pi-arrow-right-arrow-left"
                        style="font-size: 10px"
                      ></i>
                      <span
                        class="truncate"
                        [title]="travelInfo!.shiftedEventTitle!"
                        >{{ travelInfo!.shiftedEventTitle }}</span
                      >
                    </div>
                  }
                  @if (travelInfo) {
                    <div class="slot-details">
                      @if (
                        travelInfo.isFirstSlotOfDay && travelInfo.travelFromHome
                      ) {
                        <span class="detail-chip text-blue-400"
                          ><i class="pi pi-home"></i>
                          {{
                            travelInfo.travelFromHome | number: '1.0-0'
                          }}min</span
                        >
                      } @else if (travelInfo.travelFromPrevious) {
                        <span class="detail-chip text-blue-400"
                          ><i class="pi pi-car"></i>
                          {{
                            travelInfo.travelFromPrevious | number: '1.0-0'
                          }}min</span
                        >
                      }
                      @if (
                        travelInfo.isFirstSlotOfDay &&
                        travelInfo.homeDepartureTime
                      ) {
                        <span class="detail-chip text-cyan-400"
                          ><i class="pi pi-sign-in"></i>
                          {{ availableSlot.start | date: 'HH:mm' }}</span
                        >
                      } @else if (
                        !travelInfo.isFirstSlotOfDay &&
                        travelInfo.estimatedArrival
                      ) {
                        <span class="detail-chip text-cyan-400"
                          ><i class="pi pi-sign-in"></i>
                          {{
                            travelInfo.estimatedArrival | date: 'HH:mm'
                          }}</span
                        >
                      }
                      @if (
                        travelInfo.effectiveAvailableTime !== null &&
                        travelInfo.effectiveAvailableTime !== undefined
                      ) {
                        <span
                          class="detail-chip"
                          [class.text-green-400]="
                            travelInfo.effectiveAvailableTime >=
                            interventionDuration
                          "
                          [class.text-yellow-400]="
                            travelInfo.effectiveAvailableTime <
                              interventionDuration && travelInfo.needsAdjustment
                          "
                          [class.text-red-400]="
                            travelInfo.effectiveAvailableTime <
                              interventionDuration &&
                            !travelInfo.needsAdjustment
                          "
                        >
                          <i class="pi pi-clock"></i>
                          {{
                            formatDuration(travelInfo.effectiveAvailableTime)
                          }}
                        </span>
                      }
                      @if (
                        travelInfo.scenarioAddedKm !== null &&
                        travelInfo.scenarioAddedKm !== undefined
                      ) {
                        <span
                          class="detail-chip"
                          [class.text-green-400]="
                            travelInfo.scenarioAddedKm <= 5
                          "
                          [class.text-cyan-400]="
                            travelInfo.scenarioAddedKm > 5 &&
                            travelInfo.scenarioAddedKm <= 15
                          "
                          [class.text-yellow-400]="
                            travelInfo.scenarioAddedKm > 15 &&
                            travelInfo.scenarioAddedKm <= 30
                          "
                          [class.text-orange-400]="
                            travelInfo.scenarioAddedKm > 30
                          "
                        >
                          <i class="pi pi-map"></i> +{{
                            travelInfo.scenarioAddedKm | number: '1.0-0'
                          }}km
                        </span>
                      }
                    </div>
                  }
                </div>
              } @empty {
                <div class="empty-state">
                  <i class="pi pi-exclamation-triangle text-red-400"></i>
                  <span class="text-xs text-red-400"
                    >Aucun créneau disponible</span
                  >
                </div>
              }
            }
          </div>
        } @else {
          <div class="empty-state">
            <i class="pi pi-exclamation-triangle text-red-400"></i>
            <span class="text-xs text-red-400"
              >Aucun créneau · {{ interventionDuration }}min requis</span
            >
          </div>
        }

        <!-- Busy slots -->
        @if (
          selectedInterventionAvailabilities.availabilities.busy_slots.length >
          0
        ) {
          <div class="busy-section">
            <button
              type="button"
              class="busy-toggle"
              (click)="toggleBusySlots()"
              aria-label="Afficher ou masquer les créneaux occupés"
            >
              <span
                >Occupé ({{
                  selectedInterventionAvailabilities.availabilities.busy_slots
                    .length
                }})</span
              >
              <i
                class="pi"
                [class.pi-chevron-down]="!showBusySlots"
                [class.pi-chevron-up]="showBusySlots"
              ></i>
            </button>
            @if (showBusySlots) {
              @for (
                busySlot of selectedInterventionAvailabilities.availabilities
                  .busy_slots;
                track $index
              ) {
                <div
                  class="busy-slot"
                  [ngClass]="{
                    'busy-slot--shiftable':
                      busySlot.type === 'event' && busySlot.doNotShift !== true,
                    'busy-slot--locked': busySlot.doNotShift === true,
                  }"
                >
                  <span
                    class="text-xs truncate"
                    [class.text-orange-300]="
                      busySlot.type !== 'event' || busySlot.doNotShift === true
                    "
                    [class.text-purple-300]="
                      busySlot.type === 'event' && busySlot.doNotShift !== true
                    "
                    [title]="busySlot.title"
                    >{{ busySlot.title }}</span
                  >
                  <span class="text-xs text-orange-200"
                    >{{ busySlot.start | date: 'HH:mm' }}-{{
                      busySlot.end | date: 'HH:mm'
                    }}</span
                  >
                  @if (
                    busySlot.type === 'event' && busySlot.doNotShift !== true
                  ) {
                    <span class="busy-type busy-type--shiftable"
                      ><i
                        class="pi pi-arrow-right-arrow-left"
                        style="font-size: 9px"
                      ></i>
                      décalable</span
                    >
                  } @else if (busySlot.doNotShift === true) {
                    <span class="busy-type busy-type--locked"
                      ><i class="pi pi-lock" style="font-size: 9px"></i>
                      verrouillé</span
                    >
                  } @else {
                    <span class="busy-type">{{ busySlot.type }}</span>
                  }
                </div>
              }
            }
          </div>
        }
      } @else {
        <div class="empty-state">
          <span class="text-xs text-neutral-400"
            >Aucune disponibilité trouvée</span
          >
        </div>
      }
    </div>
  } @else if (activeTab === 'emptyDays') {
    <div class="availabilities-scroll">
      @if (loadingEmptyDays) {
        <div class="empty-state">
          <p-progressSpinner [style]="{ width: '24px', height: '24px' }" />
          <span class="text-xs text-neutral-400"
            >Recherche des journées creuses...</span
          >
        </div>
      } @else if (emptyDaysSlots.length > 0) {
        <div class="slots-list">
          @for (day of emptyDaysSlots; track day.date) {
            <div class="day-card">
              <div class="day-header">
                <div class="flex items-center gap-1">
                  <i
                    class="pi pi-sun text-purple-400"
                    style="font-size: 10px"
                  ></i>
                  <span class="text-xs font-medium text-purple-300">{{
                    day.dayLabel
                  }}</span>
                </div>
                <span class="text-xs text-neutral-400">{{
                  formatDuration(day.totalAvailableMinutes)
                }}</span>
              </div>
              <div class="flex items-center gap-1 flex-wrap mb-1">
                @for (rawSlot of day.slots; track $index) {
                  <span class="raw-slot-chip"
                    >{{ rawSlot.start | date: 'HH:mm' }}-{{
                      rawSlot.end | date: 'HH:mm'
                    }}</span
                  >
                }
              </div>
              @for (slot of getEmptyDaySlotsChunked(day); track $index) {
                <div
                  class="slot-card slot-empty-day"
                  (click)="
                    onEmptyDaySlotClick(
                      slot,
                      selectedInterventionAvailabilities?.user_email ||
                        selectedTechnicianDirect?.email ||
                        '',
                      day.date
                    )
                  "
                >
                  <div class="flex items-center justify-between">
                    <span class="slot-time"
                      >{{ slot.start | date: 'HH:mm' }} →
                      {{ slot.end | date: 'HH:mm' }}</span
                    >
                    <span class="slot-badge bg-purple-600">LIBRE</span>
                  </div>
                  <div class="slot-details">
                    <span class="detail-chip text-neutral-400">{{
                      formatDuration(getEmptyDaySlotDuration(slot))
                    }}</span>
                  </div>
                </div>
              } @empty {
                <div class="text-xs text-neutral-400 text-center py-1">
                  Durée trop longue pour les plages disponibles
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="empty-state">
          <i class="pi pi-info-circle text-neutral-500"></i>
          <span class="text-xs text-neutral-400"
            >Aucune journée creuse sur cette période</span
          >
        </div>
      }
    </div>
  }
} @else {
  <div class="empty-state">
    <span class="text-xs text-neutral-400"
      >Sélectionnez une intervention pour voir les disponibilités</span
    >
  </div>
}
